import { Space, Typography } from 'antd'
import React from 'react'

import { PayloadError, RowError } from './models'

const { Title, Paragraph } = Typography

interface Props {
  payload: PayloadError | null
}

export const LoadFileError = ({ payload }: Props) => {
  let errorList: RowError[]

  if (!payload) return null

  if (Array.isArray(payload.error)) {
    errorList = payload.error
  } else {
    errorList = payload.error_message.invalidIsins.map((isin) => ({
      itemIndex: null,
      entity: { isin },
      errors: { error: [{ msg: `${payload.error}` }] },
    }))
  }

  return (
    <Space direction="vertical" className="full-width">
      {errorList.map((row) => (
        <div key={row.itemIndex}>
          <Title level={5}>{row.itemIndex ? `#${row.itemIndex + 1} - ${row.entity.isin}` : row.entity.isin}</Title>
          {Object.keys(row.errors).map((name: string) => {
            const message = row.errors[name].map(({ msg }) => msg).join(', ')

            return <Paragraph key={name}>{`${name}: ${message}`}</Paragraph>
          })}
        </div>
      ))}
    </Space>
  )
}
